var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.categories, function(category) {
      return _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "custom-categories-table-row custom-data-row" },
            [
              _c("div", { staticClass: "custom-categories-table-label" }, [
                _vm._v(_vm._s(category.name))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "custom-categories-table-label" }, [
                _c(
                  "div",
                  { staticClass: "buttons-group-collection field-edit" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "table-svg-button",
                        on: {
                          click: function($event) {
                            _vm.addCategory(
                              category.id,
                              _vm.getHierarchy(category.id)
                            )
                          }
                        }
                      },
                      [_c("SVGPlus", { attrs: { width: 20, height: 20 } })],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "table-svg-button",
                        on: {
                          click: function($event) {
                            _vm.editCategory(
                              category,
                              _vm.getHierarchy(category.id)
                            )
                          }
                        }
                      },
                      [_c("SVGAdminEditRow")],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "table-svg-button",
                        on: {
                          click: function($event) {
                            return _vm.confirm(category)
                          }
                        }
                      },
                      [_c("SVGAdminDeleteRow")],
                      1
                    )
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("AdminCategoriesRecursive", {
            staticStyle: {
              "margin-left": "15px",
              "border-left": "2px solid #c5c5c5"
            },
            attrs: {
              parents: _vm.getHierarchy(category.id),
              categories: category.subcategories
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }